import * as Moment from "moment";
import { WesternYearConverter, IManualDateFormatConvertible } from ".";

export class JapaneseDateFormatConverter implements IManualDateFormatConvertible {
  getEraName(): string {
    return "$JJJ$";
  }

  getShortEraName(): string {
    return "$JJ$";
  }

  getEraNameInitial(): string {
    return "$J$";
  }

  getMonthName(moment: Moment.Moment): string {
    if (!moment) {
      return "[  月]";
    }
    return "[" + (moment.month() + 1) + "月]";
  }

  getShortMonthName(moment: Moment.Moment): string {
    if (!moment) {
      return "  ";
    }
    return (moment.month() + 1) + "";
  }

  getDayOfWeek(moment: Moment.Moment): string {
    if (!moment) {
      return "[  曜日]";
    }
    switch (moment.weekday()) {
      case 0: return "[日曜日]";
      case 1: return "[月曜日]";
      case 2: return "[火曜日]";
      case 3: return "[水曜日]";
      case 4: return "[木曜日]";
      case 5: return "[金曜日]";
      case 6: return "[土曜日]";
      default: return "[  曜日]";
    }
  }

  getShortDayOfWeek(moment: Moment.Moment): string {
    if (!moment) {
      return "  ";
    }
    switch (moment.weekday()) {
      case 0: return "[日]";
      case 1: return "[月]";
      case 2: return "[火]";
      case 3: return "[水]";
      case 4: return "[木]";
      case 5: return "[金]";
      case 6: return "[土]";
      default: return "  ";
    }
  }

  getDateOrdinal(moment: Moment.Moment) {
    return "";
  }

  /**
   * lengthは長さというよりは、実質的には変換のモードを指定している
   */
  getYear(moment: Moment.Moment, length: number): string {
    if (length === 1) {
      return "$Y$";
    }
    if (length === 2) {
      return "$YY$";
    }
    const converter = new WesternYearConverter();
    return converter.getYear(moment, length);
}
}
